"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcDate = void 0;
exports.calculateDates = calculateDates;
exports.dateFormat = dateFormat;
exports.getToday = getToday;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.to-string");
var _validate = require("@/utils/validate");
var calcDate = exports.calcDate = function calcDate(date1, date2) {
  var date3 = date2 - date1;
  var days = Math.floor(date3 / (24 * 3600 * 1000));
  var leave1 = date3 % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));
  var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(date3 / 1000);
  return {
    leave1: leave1,
    leave2: leave2,
    leave3: leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};
function getToday() {
  var date = new Date();
  var seperator1 = '-';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
function calculateDates(date, days) {
  var datefrom = new Date(date);
  datefrom.setDate(datefrom.getDate() + days);
  var y1 = datefrom.getFullYear();
  var m1 = datefrom.getMonth() + 1 + '';
  var d1 = datefrom.getDate() + '';
  if (m1.length === 1) {
    m1 = '0' + m1;
  }
  if (d1.length === 1) {
    d1 = '0' + d1;
  }
  return y1 + '-' + m1 + '-' + d1;
}

/**
 * 日期格式化
 * @param fmt
 * @param date
 * @returns {*}
 */
function dateFormat(fmt, date) {
  if (!(0, _validate.validateNull)(date)) {
    date = new Date(date);
    var ret;
    var opt = {
      'Y+': date.getFullYear().toString(),
      // 年
      'M+': (date.getMonth() + 1).toString(),
      // 月
      'D+': date.getDate().toString(),
      // 日
      'h+': date.getHours().toString(),
      // 时
      'm+': date.getMinutes().toString(),
      // 分
      's+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (var k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
      }
    }
    return fmt;
  } else {
    return '';
  }
}